import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { AdminPageShell } from "@/components/shared/admin-page-shell";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { RolesTable } from "@/features/roles/components/RolesTable";
import { useRoles } from "@/features/roles/hooks/useRolesQueries";
import { Pages } from "@/constants/enums";
import { appPath } from "@/constants/paths";

export default function RolesPage() {
  const { data: roles = [], isLoading, error } = useRoles();

  return (
    <AdminPageShell
      title="إدارة الأدوار"
      description="إنشاء وإدارة الأدوار المخصصة وتعيينها للمستخدمين"
      actions={
        <Button asChild>
          <Link to={appPath(Pages.ROLES, "new")}>
            <Plus className="size-4" />
            دور جديد
          </Link>
        </Button>
      }
    >
      {isLoading ? (
        <div className="flex justify-center py-12">
          <Spinner className="size-6" />
        </div>
      ) : error ? (
        <p className="text-sm text-destructive">تعذر تحميل الأدوار</p>
      ) : (
        <RolesTable roles={roles} />
      )}
    </AdminPageShell>
  );
}
